<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <template v-for="route in routes">
        <el-tooltip :key="route.name + '_' + route.path" :disabled="sidebar.opened" :content="route.name" placement="right" effect="light">
          <div :class="route.url === nowRouteInfo.url ? 'one-step-nav_selected' : ''" class="side-nav_list" @click="choseOneStepNav(route)">
            <template v-if="route.meta">
              <i v-if="route.meta.icon.indexOf('el-') > -1 || route.meta.icon.indexOf('icon-') > -1" :class="[route.meta.icon, 'iconfont']" />
              <svg-icon v-else :icon-class="route.meta.icon" />
            </template>
            <span>{{ route.name }}</span>
          </div>
        </el-tooltip>
      </template>
      <img v-if="sidebar.opened" class="side-logo" src="https://cdp-wx-tunel-prod.oss-cn-shenzhen.aliyuncs.com/skynet/media/side_logo_new.png" />
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
export default {
  computed: {
    ...mapGetters(["avatar", "sidebar"]),
    ...mapState("app", ["nowRouteInfo"]),
    ...mapState("user", ["routes", "userInfo"]),
    ...mapState("tagsView", ["sysBelong"])
  },
  watch: {
    // 根据当前地址，判断左侧菜单选中
    $route: {
      handler() {
        // 因为会有同一个菜单，出现在2个中心菜单中，为了避免同样的菜单点击后，左侧菜单跳走的问题
        if (this.nowRouteInfo.url !== this.sysBelong) {
          const leftNav = this.routes.filter(item => item.url === this.sysBelong)?.[0]
          if (leftNav) {
            this.$store.dispatch("app/saveNowRouteInfo", leftNav)
          }
        }
      }
      // immediate: true
    }
  },
  mounted() {
    const leftNav = this.routes.filter(item => item.url === this.$route.path)?.[0]
    if (leftNav) {
      this.choseOneStepNav(leftNav)
    } else {
      setTimeout(() => {
        const leftNav = this.routes.filter(item => item.url === this.$route.path)?.[0]
        if (leftNav) {
          this.choseOneStepNav(leftNav)
        }
      }, 1000)
    }
  },
  methods: {
    // 选择左侧一级菜单
    choseOneStepNav(route, toUrl = "") {
      // 拿到该一级菜单，并存入store.
      // 子路由留给顶部导航用
      this.$store.dispatch("app/saveNowRouteInfo", route)
      if (toUrl) {
        this.$router.push({ path: toUrl })
        return
      }
      // 默认跳转该大路由下第一个页面
      let fullPath = ""
      if (route.children && route.children.length > 0) {
        if (route.children[0].children && route.children[0].children.length > 0) {
          fullPath = route.url + "#" + route.children[0].children[0].url
          route.children[0].children[0].fullPath = fullPath
          this.$store.dispatch("tagsView/addView", route.children[0].children[0])
        } else {
          fullPath = route.url + "#" + route.children[0].url
          route.children[0].fullPath = fullPath
          this.$store.dispatch("tagsView/addView", route.children[0])
        }
      }
      this.$router.push({ path: fullPath })
      // 如果是微营销菜单，并且拥有微营销工作台,并且是微营销属性，则默认打开一个微营销工作台的标签
      setTimeout(() => {
        if (route.url === "/userData" && this.userInfo.isMarketing) {
          const haveWctDataPage = route.children.filter(item => item.url === "/userData/marketPage")?.[0]
          haveWctDataPage.fullPath = route.url + "#" + haveWctDataPage.url
          this.$store.dispatch("tagsView/addView", haveWctDataPage)
        }
      }, 200)
    }
  }
}
</script>
<style scoped lang="scss">
.side-nav_list {
  width: 100%;
  height: 40px;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  span {
    opacity: 0.65;
    flex-shrink: 0;
  }
  i {
    margin: 0px 20px;
    flex-shrink: 0;
  }
  svg {
    margin: 0px 20px !important;
    flex-shrink: 0;
  }
  &:hover {
    background: #ebf4ff;
    color: #3296fa;
  }
}
.one-step-nav_selected {
  background: #ebf4ff !important;
  color: #3296fa !important;
}
.side-logo {
  width: 152px;
  left: 50%;
  margin-left: -76px;
  position: absolute;
  bottom: 48px;
}
</style>
